import { organisationNodes } from './OrganisationNodes';
import { jobArchitecture } from './jobArchitecture';
import { login } from './login';
import { baseRegistry } from './baseRegistry';
import { roleAccess } from './RoleAccess';
import { dataImport } from './DataImport';

export const api = {
    baseRegistry,
    dataImport,
    login,
    organisationNodes,
    jobArchitecture,
    roleAccess
};
